const state = () => ({
  lastStoreId: null,
  updatedAt: null,
});

const getters = {
  getLastStoreId: (state) => state.lastStoreId,
  getLastStoreUpdatedAt: (state) => state.updatedAt,
};

const actions = {
  setLastStoreId({ commit }, storeId) {
    commit('SET_LAST_STORE_ID', storeId);
  },
  clearStoreSelection({ commit }) {
    commit('CLEAR_STORE_SELECTION');
  },
};

const mutations = {
  SET_LAST_STORE_ID(state, storeId) {
    const parsed =
      storeId === null || storeId === undefined || storeId === ''
        ? null
        : parseInt(storeId, 10);
    state.lastStoreId = Number.isFinite(parsed) ? parsed : null;
    state.updatedAt = new Date().getTime();
  },
  CLEAR_STORE_SELECTION(state) {
    state.lastStoreId = null;
    state.updatedAt = null;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

